<template>

    <label class="switch">
        <input type="checkbox" :checked="checked" @click="darkmodeHandler"/>
        <span class="slider round">
            <div class="imgContainer">
                <span>🌞</span>
                <span>🌜</span>                
            </div>
        </span>
    </label>
  
</template>

<script>

export default {

    props: [
        "propsChecked"
    ],

    data(){
        return({
            checked: this.propsChecked
        })
    },

    methods: {
        darkmodeHandler(){
            this.checked = !this.checked;
            this.$emit("value", !this.checked)
        }
    }

}

</script>

<style>

.switch {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 24px;
    margin-left: 5px;
}
  
.switch input { 
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color:  #3d3f47;
    -webkit-transition: .4s;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 24px;
    width: 24px;
    border: 2px solid #4d4d4d;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
}

input:checked + .slider:before {
    -webkit-transform: translateX(27px);
    -ms-transform: translateX(27px);
    transform: translateX(27px);
}

/* Rounded sliders */
.slider.round {
    border-radius: 30px;
}

.slider.round:before {
    border-radius: 50%;
}

input:hover + .slider:before{
    box-shadow: 0 0 0 5px #11f6e796;
}

.imgContainer{
    display: flex;
    justify-content: space-around;
    align-items: center;
}

</style>